import { render, staticRenderFns } from "./UserEventList.vue?vue&type=template&id=825cec18"
import script from "./UserEventList.js?vue&type=script&lang=js&external"
export * from "./UserEventList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports